import React from 'react';
import bg8 from '../../assets/images/background/bg-8.png';
import bg7 from '../../assets/images/background/bg-7.png';
import { useContent } from '../../services';

const whyIcons = {
  'why-icon-1.png': require('../../assets/images/resource/why-icon-1.png'),
  'why-icon-2.png': require('../../assets/images/resource/why-icon-2.png'),
  'why-icon-3.png': require('../../assets/images/resource/why-icon-3.png'),
  'why-icon-4.png': require('../../assets/images/resource/why-icon-4.png'),
};

function Whyus() {
  const { data: whyUs, loading } = useContent('homeWhyUs');

  if (loading || !whyUs) return null;

  return (
    <>
      <section className="why-us">
        <div className="left-bg">
          <img src={bg8} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg7} alt="" title="" />
        </div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>{whyUs.subtitle}</span>
            </div>
            <div className="pattern-image">
              <img
                src={require('../../assets/images/icons/separator.svg').default}
                alt="mySvgImage"
              />
            </div>

            <h2>{whyUs.title}</h2>
          </div>
          <div className="row clearfix">
            {whyUs.items.map((data, index) => (
              <div key={data.id} className="why-block col-xl-3 col-lg-6 col-md-6 col-sm-12"
              >
                <div
                  className="inner-box wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay={`${index * 300}ms`}
                >
                  <div className="icon-box">
                    <img src={whyIcons[data.icon]} alt="" />
                  </div>
                  <h4>{data.title}</h4>
                  <div className="text">{data.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Whyus;
